import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import Sidebar from '../../components/Sidebar';

const CountryLeads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const response = await fetch('https://telkosh.onrender.com/api/leads/country');
        if (!response.ok) throw new Error('Failed to fetch leads');

        const data = await response.json();
        setLeads(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, []);

  const handleExport = () => {
    if (leads.length === 0) {
      alert('No leads available to export.');
      return;
    }

    const csvHeader = 'Sr No,Name,Email,Phone,Company,Product,Website,Message,Captured At\n';
    const csvRows = leads
      .map((lead, index) =>
        `${index + 1},${lead.name},${lead.email},${lead.phone},${lead.companyName},${lead.product},${lead.website},${lead.message},${new Date(lead.createdAt || lead.timestamp).toLocaleString()}`
      )
      .join('\n');
    

    const csvContent = `data:text/csv;charset=utf-8,${csvHeader}${csvRows}`;
    const encodedUri = encodeURI(csvContent);

    const link = document.createElement('a');
    link.href = encodedUri;
    link.download = 'homepage_leads.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 ml-16">
        <Navbar />
        <div className="p-6 mt-16">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-700">Country Leads</h2>
            <button
              onClick={handleExport}
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-200"
              disabled={leads.length === 0}
            >
              Export CSV
            </button>
          </div>

          {/* Loading State */}
          {loading && (
            <div className="flex justify-center items-center py-10">
              <span className="text-gray-500">Loading leads...</span>
            </div>
          )}

          {/* Error State */}
          {error && (
            <div className="text-red-500 bg-red-100 p-3 rounded-md mb-4">
              {error}
            </div>
          )}

          {/* Leads Table */}
          {!loading && !error && leads.length > 0 ? (
            <div className="overflow-x-auto bg-white shadow-md rounded-lg">
              <table className="min-w-full text-sm">
              <thead>
  <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
    <th className="py-3 px-4 text-left">Sr No</th>
    <th className="py-3 px-4 text-left">Name</th>
    <th className="py-3 px-4 text-left">Email</th>
    <th className="py-3 px-4 text-left">Phone</th>
    <th className="py-3 px-4 text-left">Company</th>
    <th className="py-3 px-4 text-left">Product</th>
    <th className="py-3 px-4 text-left">Website</th>
    <th className="py-3 px-4 text-left">Message</th>
    <th className="py-3 px-4 text-left">Captured At</th>
  </tr>
</thead>

                <tbody>
  {leads.map((lead, index) => (
    <tr
      key={lead.id || index}
      className="border-b border-gray-200 hover:bg-gray-100 transition duration-150"
    >
      <td className="py-3 px-4">{index + 1}</td>
      <td className="py-3 px-4">{lead.name}</td>
      <td className="py-3 px-4">{lead.email}</td>
      <td className="py-3 px-4">{lead.phone}</td>
      <td className="py-3 px-4">{lead.companyName}</td>
      <td className="py-3 px-4">{lead.product}</td>
      <td className="py-3 px-4">{lead.website}</td>
      <td className="py-3 px-4">{lead.message}</td>
      <td className="py-3 px-4">
        {new Date(lead.createdAt || lead.timestamp).toLocaleString()}
      </td>
    </tr>
  ))}
</tbody>

              </table>
            </div>
          ) : (
            !loading &&
            !error && (
              <div className="flex justify-center items-center py-10 text-gray-500">
                No leads available.
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default CountryLeads;
